define(
    'models/global.model',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'models/forum.model',
        'models/foundation.model',
        'models/awards.model',
        'models/breadcrumbs.model',
        'collections/admin_menu_links.collection',
        'collections/users.collection',
        'models/highlight_code.model',
        'models/reputation.model'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox,

        ForumModel,
        FoundationModel,
        AwardsModel,
        BreadcrumbsModel,
        AdminMenuLinksCollection,
        UsersCollection,
        HighlightCodeModel,
        ReputationModel
        )
    {
        var _ = Loader._;
        var $ = Loader.$;
        var Cookie = Loader.Cookie;

        // Перезаписываем нативный метод Backbone, для того, чтобы можно было создавать вложенные модели.
        Loader.Backbone.Model.prototype.toJSON = function() {
            if (this._isSerializing) {
                return this.id || this.cid;
            }
            this._isSerializing = true;
            var json = _.clone(this.attributes);
            _.each(json, function(value, name) {
                (value != null) && _.isFunction(value.toJSON) && (json[name] = value.toJSON());
            });
            this._isSerializing = false;
            return json;
        };
        // Перезаписываем нативный метод Backbone, для того, чтобы была опция делать коллекции не массивом, а объектом
        Loader.Backbone.Collection.prototype.toJSON = function(options) {
            if (this.toJSONmode == 'obj') {
                var obj = {},
                    length = 0;

                this.each(function(model){
                    var value = model.toJSON(options);
                    var key = value.id;

                    obj[key] = value;
                    length++;
                });

                obj.length = length;
                return obj;
            } else {
                return this.map(function(model){ return model.toJSON(options); });
            }
        };

        var GlobalModel = Loader.Backbone.Model.extend({

            defaults: {
                forum:       false,
                breadcrumbs: false,
                foundation:  false,
                awards:      false,
                reputation:  false
            },

            initialize: function()
            {
                this.set('forum', new ForumModel.initialize(this));
                this.set('breadcrumbs', new BreadcrumbsModel.initialize(this));
                this.set('foundation', new FoundationModel.initialize(this));
                this.set('awards', new AwardsModel.initialize(this));
                this.set('adminMenuLinks', new AdminMenuLinksCollection());
                this.set('users', new UsersCollection());
                this.set('highlightCode', new HighlightCodeModel.initialize(this));
                this.set('reputation', new ReputationModel.initialize(this));

                Sandbox.transport.io.subscribe(
                    Config.transport.io.channels.init,
                    function(data){
                        console.log('init ok');
                    }
                );
            },

            setUserConfigs: function(callback)
            {
                var Rusff = window['RusffCore'] || window['Rusff'] || {};

                if (!Rusff.sets) {
                    Rusff.sets = {};
                }

                this.get('forum').collector(_.once(function(result){

                    Config.modules.awards.enabled           = result.board_award_use_mod == 1;
                    Config.modules.awards.board_award_sort  = result.board_award_sort;
                    Config.modules.awards.moderatorsAccess  = result.board_award_use_moderate == 1;
                    Config.modules.awards.detail            = result.board_award_detail == 1;
                    Config.modules.awards.showInPost        = result.board_award_echo_awards == 1;
                    Config.modules.awards.showInProfile     = result.board_award_echo_profile_awards == 1;
                    Config.modules.awards.showWithoutAwards = result.board_award_echo_without_awards == 1;
                    Config.modules.awards.title             = Rusff.sets.awardsTitle || "Награды";
                    Config.modules.awards.awardsNominativeTitle = Rusff.sets.awardsNominativeTitle || "Награда";
                    Config.modules.awards.awardsGenitiveTitle  = Rusff.sets.awardsGenitiveTitle || "Наград";
                    Config.modules.awards.userAwardsTitle   = Rusff.sets.userAwardsTitle || "Награды пользователя {username}";
                    Config.modules.awards.emptyTitle        = Rusff.sets.awardsEmpty || "Нет наград";
                    Config.modules.awards.listAwardsTitle   = Rusff.sets.listAwardsTitle || "Список наград";
                    Config.modules.awards.showAwardsTitle   = Rusff.sets.showAwardsTitle || "вывести награды";
                    Config.modules.awards.qtyAwardsTitle    = Rusff.sets.qtyAwardsTitle  || "Количество наград";
                    Config.modules.boardDescription.enabled = result.service == 'rusff';
                    Config.modules.textareaResizer.enabled  = result.service == 'rusff';
                    Config.modules.notes.enabled            = result.service == 'rusff';
                    Config.modules.reports.enabled          = result.service == 'rusff' || result.board_reports_en == 1;
                    Config.modules.twitter.enabled          = result.service == 'rusff';
                    Config.modules.reputation.enabled       = result.service == 'rusff' || result.board_reputation_en == 1;
                    Config.modules.notifications.enabled    = result.service == 'rusff' || result.board_notifications_en == 1;

                    if (result.service == 'rusff') {
                        if (Rusff.sets.foundation == 2) {
                            Config.modules.foundation.type = "credits";
                        }
                        if (Rusff.sets.show_reportBtn == 0) {
                            Config.modules.reports.enabled = false;
                        }
                        if (Rusff.sets.reputation == 0) {
                            Config.modules.reputation.enabled = false;
                        }
                        if (Rusff.sets.notifications == 0) {
                            Config.modules.notifications.enabled = false;
                        }
                    }
                    else {
                        if (result.board_foundation_en == 0)
                            Config.modules.foundation.type = "credits";
                    }

                    if (Config.modules.notifications.enabled) {
                        Config.transport.io.enabled = true;
                        Sandbox.transport.io.initialize();
                    } else {
                        Config.transport.io.enabled = false;
                    }

                    _.isFunction(callback) && callback();

                }));
            }

        });

        return GlobalModel;
    }
);

